import React, {useEffect, useRef, useState} from 'react'
import { usePrincipal } from '../../../hooks/Principal/usePrincipal'
import * as echarts from 'echarts';
import SkeletonGraficoBarras from "./SkeletonGraficoBarras";

const ContenedorOperatividad = () => {
  const refGrafico = useRef(null)
  const refInterval = useRef(null)
  const refCharts = useRef(null)
  const hookPrincipal = usePrincipal()
  const [estaCargando, setEstaCargando] = useState(false)

  useEffect(() => {
    (async () => {
      setEstaCargando(true)
      await funcionProcesamiento()
      setEstaCargando(false)
      refInterval.current = setInterval(async () => {
        await funcionProcesamiento()
      }, 10000);
    })();
    return () => {
      clearInterval(refInterval.current)
    }
  },[])

  const funcionProcesamiento = async () => {
    const operatividadPorEmpresa = await hookPrincipal.listarOperatividadPorEmpresa()
    crearGrafico(operatividadPorEmpresa)
  }
  
  const crearGrafico = (operatividadPorEmpresa) => {
    !refCharts.current && (refCharts.current = echarts.init(refGrafico.current));

    const seriesAlertas = [
      {
        name: "Unidades operativas",
        type: "bar",
        stack: 'Ad',
        emphasis: {
          focus: 'series'
        },
        // barWidth: 25,
        color: '#60b831',
        data: operatividadPorEmpresa.map(e => e.flotaOperativa)
      },
      {
        name: "Unidades no operativas",
        type: "bar",
        stack: 'Ad',
        emphasis: {
          focus: 'series'
        },
        // barWidth: 25,
        color: '#ec0a17',
        data: operatividadPorEmpresa.map(e => (Number(e.flotaTotal) - Number(e.flotaOperativa)))
      }
    ]

    const option = {
      tooltip: {
        trigger: 'axis',
        confine: true,
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          const cantidadTotal = params.reduce((sum, item) => sum + Number(item.value), 0);
          const cantidadOperativos = Number(params[0].value)
          let textoToolTip = `${params[0].axisValue} <br/>`;
          params.forEach((item) => {
            textoToolTip += `${item.marker} ${item.seriesName}: ${item.value} <br/>`;
          });
          textoToolTip += `<b>Porcentaje operatividad: ${((cantidadOperativos / cantidadTotal) * 100).toFixed(2)} %</b>`;
          return textoToolTip;
        },
      },
      legend: {
        textStyle: {
          color: 'white'
        },
        bottom: 0
      },
      grid: {
        top: '3%',
        left: '3%',
        right: '3%',
        bottom: '6%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: operatividadPorEmpresa.map(data => data.nomEmpresa),
          axisLabel: {
            interval: 0,  // Muestra todas las etiquetas sin saltarse ninguna
            rotate: 45,   // Rota las etiquetas para que no se superpongan (prueba con 30, 45 o 90)
            fontSize: 12, // Ajusta el tamaño del texto
            width: 50,
            overflow: "truncate",
            color: 'white'
          },
          tooltip: {
            show: true,   // Muestra el tooltip cuando pasas el mouse sobre el label
          },
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: seriesAlertas,
    };
  
    refCharts.current.setOption(option);
  }
  
  return (
      <>
        {
          estaCargando ? <SkeletonGraficoBarras></SkeletonGraficoBarras> : <></>
        }
        <div ref={refGrafico} className={`w-full h-full ${estaCargando ? 'invisible' : ''}`}></div>
      </>
  )
}

export default ContenedorOperatividad